<div class="cm-contenido-central" style="padding: 24px;">
    <mat-accordion>
        <ng-container *ngFor="let meta of metasCriterios">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <!-- 
                    <mat-panel-title>
                        <div class="meta-code">
                            {{meta.codigo}}-{{}} V{{meta.majorVersion + '.' + meta.minorVersion}} 
                            <small style="color:#03a9f4">({{meta.criteriosSeleccionados}} de {{meta.criterios.length}})</small>
                        </div>
                    </mat-panel-title>
                    -->
                    <mat-panel-description class="min-width-ellipsis">
                        <div class="ellipsis-cont">
                            <small [matTooltip]="meta.id" matTooltipPosition="left" style="color:#03a9f4">
                                ({{meta.criteriosSeleccionados}} de {{meta.criterios.length}})
                            </small>
                            {{meta.txtIdioma}}
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <h4 class="mat-subheading-1">Criterios de evaluación</h4>
                <ul>
                    <ng-container *ngFor="let criterio of meta.criterios">
                        <li>
                            <mat-checkbox [matTooltip]="criterio.id" matTooltipPosition="left" (change)="cambiarEstado($event, criterio, meta)" [checked]="criterio.isConectado">
                                {{criterio.nombre}}
                            </mat-checkbox>
                        </li>
                    </ng-container>
                </ul>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>
</div>
<div class="cm-botones" *ngIf="!guardando">
    <button mat-button (click)="cancelar()">Finalizar</button>
</div>
